import { CreateOrganizationEventStyleDto } from "./create-organization-event-style.dto";

export class UpdateOrganizationEventStyleDto extends CreateOrganizationEventStyleDto {}
